import { minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery, pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';
var spacing = theme.spacing;
export var footerWrapper = /*#__PURE__*/css(["background:var(--neutral-white-base);box-shadow:0 ", " ", " 0 rgba(0,0,0,0.2);padding:", ";width:100%;", ""], pxToRem(-4), pxToRem(8), pxToRem(spacing.md), mediaQuery({
  min: minBreakpoints.L
}, css(["padding:", ";text-align:right;"], pxToRem(spacing.xl))));